const Polyline = {};

// Based off of [the offical Google document](https://developers.google.com/maps/documentation/utilities/polylinealgorithm)
//
// Some parts from [this implementation](http://facstaff.unca.edu/mcmcclur/GoogleMaps/EncodePolyline/PolylineEncoder.js)
// by [Mark McClure](http://facstaff.unca.edu/mcmcclur/)

function encode(coordinate, factor) {
    coordinate = Math.round(coordinate * factor);
    coordinate <<= 1;
    if (coordinate < 0) {
        coordinate = ~coordinate;
    }
    var output = '';
    while (coordinate >= 0x20) {
        output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
        coordinate >>= 5;
    }
    output += String.fromCharCode(coordinate + 63);
    return output;
}

// This is adapted from the implementation in Project-OSRM
// https://github.com/DennisOSRM/Project-OSRM-Web/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
Polyline.decode = function (str, {
    elevation = false,
    precision = 5
} = {}) {
    var index = 0;
    var lat = 0;
    var lng = 0;
    var ele = 0;
    var coordinates = [];
    var factor = 10 ** precision;

    function decodeNext() {
        // Reset shift, result, and byte
        var byte;
        var shift = 0;
        var result = 0;

        do {
            byte = str.charCodeAt(index++) - 63;
            result |= (byte & 0x1f) << shift;
            shift += 5;
        } while (byte >= 0x20);

        return ((result & 1) ? ~(result >> 1) : (result >> 1));
    }

    // Coordinates have variable length when encoded, so just keep
    // track of whether we've hit the end of the string. In each
    // loop iteration, a single coordinate is decoded.
    while (index < str.length) {
        lat += decodeNext();
        lng += decodeNext();

        if (elevation) {
            ele += decodeNext();
            coordinates.push([lat / factor, lng / factor, ele / 100]);
        } else {
            coordinates.push([lat / factor, lng / factor]);
        }
    }

    return coordinates;
};

Polyline.encode = function (coordinates, {
    precision = 5
} = {}) {
    if (!coordinates.length) return '';

    var factor = 10 ** precision;
    var output = encode(coordinates[0][0], factor) + encode(coordinates[0][1], factor);

    for (var i = 1; i < coordinates.length; i++) {
        var a = coordinates[i];
        var b = coordinates[i - 1];
        output += encode(a[0] - b[0], factor);
        output += encode(a[1] - b[1], factor);
    }

    return output;
};

export default Polyline;
